import Modal from '@/customComponents/uiComponents/modal/Modal.jsx'
import ModalHeader from '@/customComponents/uiComponents/modal/ModalHeader.jsx'

export default function ComingSoonPopup({isOpen, onClose, title}) {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalHeader title={title} onClose={onClose}/>
            <div className="flex flex-col items-center justify-center py-12 px-6 text-center gap-3">
                <h3 className="text-xl font-semibold">Coming Soon</h3>
                <p className="text-sm text-(--text-secondary) max-w-[280px] leading-relaxed mb-0">This feature is currently under development and will be available shortly.</p>
            </div>
        </Modal>
    )
}
